import { useContext } from 'react';
import { CursorContext, CursorContextType } from '../context/cursorTypes';

export function useCursorContext(): CursorContextType {
  const context = useContext(CursorContext);
  if (!context) {
    throw new Error('useCursorContext must be used within a CursorProvider');
  }
  return context;
}
